import { Box, Text } from '@primer/react';
import ComponentLayout from '~/src/layouts/component-layout';
import * as React from 'react';
export default {
  Box,
  Text,
  ComponentLayout,
  React
};